<div class="space-evenly">
    <div class="detail-page-card">
        <div class="detail-page-card-title">Gross risk matrix</div>
        <div class="detail-page-card-body padded">
            @if (grossMatrix) {
                <cerrix-riskmatrix
                    [matrix]="grossMatrix"
                    [highlightSelection]="false"
                ></cerrix-riskmatrix>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>

    <div class="detail-page-card">
        <div class="detail-page-card-title">Net risk matrix</div>
        <div class="detail-page-card-body padded">
            @if (netMatrix) {
                <cerrix-riskmatrix
                    [matrix]="netMatrix"
                    [highlightSelection]="false"
                ></cerrix-riskmatrix>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>
</div>
